import { UserState } from './types';

export const initialState: UserState = {
  loading: true,
};
